var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-text-muted truncate text-2sm"},[(!!_vm.transaction.transfer_id && !_vm.suppressTransfer)?[_vm._v(" "+_vm._s(_vm.transferComment)+" ")]:_vm._e(),_vm._v(" "+_vm._s(_vm.comment)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }